import React, { useState } from "react";
import { MdKeyboardArrowLeft } from "react-icons/md";
import flowchangerAINew from "../../../../Assets/Images/flowchangerAINew.jpeg";
// import flowchangerLogo from "../../../../Assets/Images/flowchangerLogo.png";
import loginLady from "../../../../Assets/Images/login-lady.png";
import loginSlash from "../../../../Assets/Images/login-slash.jpeg";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import EmailIcon from "@mui/icons-material/Email";
import { useGlobalContext } from "../../../../Context/GlobalContext";
import Cookies from "js-cookie";
import { useAuthContext } from "../../../../Context/AuthContext";

const RequestPassword = ({ prevStep }) => {
  const { email, setEmail } = useAuthContext();
  const { openToast, baseUrl } = useGlobalContext();
  const [loading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const requestPassword = async () => {
    setIsLoading(true);
    try {
      if (email.length === 0) {
        openToast("Please enter an email", "warning");
        return;
      }
      const result = await fetch(baseUrl + `admin/reset`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      const data = await result.json();
      if (!result.ok) {
        openToast(data?.message, "error");
      } else {
        openToast(data?.message + "Please check your email", "success");
        Cookies.set("email", email);
        Cookies.set("baseUrl", baseUrl);
      }
    } catch (error) {
      console.error("Error fetching project:", error);
    }
    finally {
      setIsLoading(false);
    }
  }
  return (
    <>
      <div className="absolute flex flex-start mt-9 ml-9">
        <MdKeyboardArrowLeft className="top-3 left-4 absolute inset-y-0 mr-5 text-white" />
        <button
          onClick={() => navigate("/authentication/login")}
          className="bg-[#8a25b0] hover:bg-[#a515db] px-9 py-2 rounded-full text-white"
        >
          Back
        </button>
      </div>

      <div className="flex justify-center items-center px-[10px] md:px-[20px] lg:px-[10px] xl:px-[10px] py-[0px] md:py-[20px] lg:py-[20px] xl:py-[20px] h-lvh min-h-screen overflow-y-auto">
        <div className="flex justify-center bg-white rounded-lg w-[100%] lg:w-[100%] xl:w-[80%] h-[350px] login-div">
          <div className="w-[100%] md:w-[50%] lg:w-[50%] xl:w-[50%]">
            <div className="space-y-2 sm:space-y-0 lg:px-[62px] xl:px-[30px] py-[40px] md:p-[30px] w-full h-">
              <div className="flex justify-center mb-[12px] font-bold text-4xl text-white">
                <img
                  src={flowchangerAINew}
                  alt="Flowchangers Logo"
                  className="h-[70px]"
                />
              </div>
              <div>
                {" "}
                <p className="mt-[10px] pb-2 text-[#8c8c8c] text-[14px] text-center">
                  {" "}
                  Please Enter a email to Reset
                </p>
              </div>
              <form onSubmit={(e) => { e.preventDefault(); requestPassword(); }}>
                <div className="relative mb-6">
                  <input
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    type="email"
                    placeholder="Email"
                    className="login-input-field"
                  />
                  <EmailIcon className="top-[10px] right-[13px] absolute text-[#8a25b0] email-icon" />
                </div>

                <button
                  type="submit"
                  className={" font-medium text-[#fff] text-center free-signup  bg-[#8a25b0] border-[#8a25b1]  rounded-full border w-full  py-[8px] px-4 " + (loading && "disabled:animate-pulse disabled:cursor-not-allowed")}
                >
                  Reset
                </button>
              </form>
            </div>
          </div>

          <div className="relative login-right md:flex justify-center items-center hidden bg-[#9181F4] px-[30px] py-[10px] w-[50%] md:w-[50%] lg:w-[50%] xl:w-[50%] text-4xl text-center">
            <div className="relative border-[#bfbfbf66] bg-[#e2e0e938] border rounded-xl w-[80%] h-[83%]">
              <h2 className="p-[18px] w-[212px] font-bold text-[32px] text-left text-white md:text-[22px]">
                Very good works are waiting for you Login Now!!!
              </h2>
              <div className="top-[-6px] right-[-42px] bottom-[0px] absolute">
                <img src={loginLady} alt="loginLady" className="h-[100%]" />
              </div>
              <div className="left-[-20px] absolute bg-white p-[10px] rounded-full">
                <img
                  src={loginSlash}
                  alt="loginSlash"
                  className="rounded-full"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RequestPassword;
